import React, { useState } from "react";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import BannerSection from '../../../components/ui/BannerSection';
import BreadcrumbNav from '../../../components/ui/BreadcrumbNav';



export default function Eventos(){

    const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Comunicação' },
    { label: 'Eventos' }
];

    const [filtroAtivo, setFiltroAtivo] = useState('todos');
    const blogData = [
  {
    id: 1,
    image: require('../../../assets/ANU_02.jpg'),
    category: 'Outorga',
    time: '16-Julho-2024',
    title: '3ª Cerimônia de Outorga de Diplomas',
    description: 'Na Cerimônia de Outorga de Diplomas doInstituto Superior Politécnico Atlântida, os formandos da turma de 2024 se reuniram ansiosos no auditório. Com discursos inspiradores, eles receberam seus diplomas.',
    link: '#'
  },
  {
    id: 2,
    image: require('../../../assets/ANU_02_4.jpg'),
    category: 'Comemoração',
    time: '07-Setembro-2023  | 09H - 12H',
    title: '5ª Jornada Científica Geral',
    description: 'No tradicional evento do Baptismo dos Caloiros, os novos estudantes se reuniram em um clima de excitação e nervosismo, eles participaram de rituais simbólicos e receberam as boas-vindas da comunidade acadêmica. Após o evento, os caloiros se integraram ainda mais à vida universitária,',
    link: '#'
  },
  {
    id: 3,
    image: require('../../../assets/ANU_02_10.jpg'),
    category: 'Investigação',
    time: '07-Abril-2023 ',
    title: 'Juventude Investigadora: Construindo o Futuro da Ciência',
    description: 'O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o avanço do conhecimento científico.',
    link: '#'
  }
  ,
  {
    id: 4,
    image: require('../../../assets/ANU_02_11.jpg'),
    category: 'Comemoração',
    time: '07-Outubro-2023 ',
    title: 'Juventude, Conhecimento e Segurança: Um Compromisso Social',
    description: 'A atividade realizada, sob o tema “Juventude, Conhecimento e Segurança: Um Compromisso Social” marcou um momento de grande significado para a comunidade académica e para as forças de segurança',
    link: '#'
  }
  ,
  {
    id: 5,
    image: require('../../../assets/ANU_02_6.jpg'),
    category: 'Evento Cultural',
    time: '22-Agosto-2023 ',
    title: 'Entre Letras e Ideias: Construindo Conhecimento Através da Leitura',
    description: 'A Feira do Livro realizada sob o tema “Entre Letras e Ideias: Construindo Conhecimento Através da Leitura” celebrou a leitura como uma ponte viva entre o saber e a imaginação, entre o passado e o futuro.',
    link: '#'
  }
  ,
  {
    id: 6,
    image: require('../../../assets/ANU_02_5.jpg'),
    category: 'Área Científica',
    time: '05-Fevereiro-2024  ',
    title: 'Semana da Investigação e Extensão Universitária',
    description: 'Esta atividade não apenas valorizou o saber produzido no ambiente acadêmico, mas também fortaleceu a relação entre a universidade e a sociedade, evidenciando o compromisso institucional com a formação integral dos estudantes e com o desenvolvimento sustentável da região.',
    link: '#'
  }
  ,
  {
    id: 7,
    image: require('../../../assets/ANU_02_7.jpg'),
    category: 'Área Científica',
    time: '14-Março-2023 ',
    title: '5ª Jornada Científica Geral',
    description: 'A 5ª Jornada Científica Geral foi um marco no calendário acadêmico do Instituto Superior, reunindo estudantes, professores, investigadores e membros da comunidade em um espaço de partilha de conhecimento, experiências e inovação.',
    link: '#'
  }
  ,
  {
    id: 8,
    image: require('../../../assets/ANU_02_8.jpg'),
    category: 'Evento Cultural',
    time: '23-Maio-2024  ',
    title: 'A Universidade como Espaço de Produção de Saberes e Impacto Social',
    description: 'O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o conhecimento científico.',
    link: '#'
  }
  ,
  {
    id: 9,
    image: require('../../../assets/ANU_04.jpg'),
    category: 'Área Científica',
    time: '07-Setembro-2023  ',
    title: 'Jornada Científica Geral',
    description: 'O evento teve como objetivo principal promover a produção e a divulgação do conhecimento científico nas diversas áreas do saber, incentivando a interdisciplinaridade, a inovação e o pensamento crítico.',
    link: '#'
  }
    ,
]

    // Destaques: por exemplo, os 3 primeiros eventos
    const destaques = blogData.slice(0, 3);
    // Todos os eventos
    const todosEventos = blogData.slice(3,13);


    // Obter categorias únicas dos eventos
    const categorias = Array.from(new Set(todosEventos.map(blog => blog.category)));

    return(
        <div className="App">
            <BannerSection
                title="Eventos"
                subtitle="Acompanhe os principais eventos do ISPA Atlântida"
                description={`Bem-vindo à seção de eventos do ISPA Atlântida, onde você pode explorar os principais acontecimentos, conferências e atividades que moldam nossa comunidade acadêmica. Fique por dentro das novidades e participe ativamente da vida institucional.`}
                backgroundImage={require('../../../assets/img2.jpg')}
                backgroundId="instituition-Banner"
            />
        <BreadcrumbNav items={caminho} />
        <header id='header'>
        <AppHeader />
        </header>
       <main>
            {/* Eventos Educacionais em Destaque */}
            <section id="blog" className="block blog-block">
                <div className="title-holder" id="title-" style={{ textAlign: 'center', marginBottom: 32 }}>
                    <h1 style={{
                        fontWeight: 800,
                        fontSize: '2.4rem',
                        letterSpacing: '-1px',
                        color: '#00761F',
                        textShadow: '0 2px 12px rgba(0,0,0,0.07)'
                    }}>
                        <i className="bi bi-star-fill" style={{ color: '#ffc107', marginRight: 10, fontSize: 32, verticalAlign: 'middle' }} />
                        Destaques Educacionais
                    </h1>
                    <p style={{
                        color: '#555',
                        fontSize: '1.1rem',
                        fontWeight: 500,
                        marginTop: 8,
                        letterSpacing: '0.5px'
                    }}>
                        - Principais Oportunidades de Aprendizagem do ISPA Atlântida -
                    </p>
                    <div style={{
                        width: 80,
                        height: 4,
                        background: 'linear-gradient(90deg, #00761F 0%, #ffc107 100%)',
                        borderRadius: 2,
                        margin: '18px auto 0'
                    }} />
                </div>
                <Container fluid>
                    <Row>
                        {destaques.map(blog => (
                            <Col sm={4} key={blog.id}>
                                <div style={{ marginTop: '12px' }} className='holder'>
                                    <Link to={`/evento/${blog.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <Card style={{ cursor: 'pointer' }}>
                                            <Card.Img variant="top" src={blog.image} />
                                            <Card.Body>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                    <span style={{ color: '#00761F', fontWeight: '700' }}>{blog.category}</span>
                                                    {blog.certificado && (
                                                        <span style={{
                                                            backgroundColor: '#007bff',
                                                            color: 'white',
                                                            padding: '2px 8px',
                                                            borderRadius: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                            Certificado
                                                        </span>
                                                    )}
                                                </div>
                                                <time>{blog.time}</time>
                                                <Card.Title>
                                                    {blog.title}
                                                </Card.Title>
                                                <Card.Text>
                                                    {blog.description}
                                                </Card.Text>
                                                {/* Informações educacionais adicionais */}
                                                <div style={{ marginTop: '12px' }}>
                                                    {blog.nivel && (
                                                        <div style={{ marginBottom: '4px' }}>
                                                            <strong>Nível:</strong> 
                                                            <span style={{ 
                                                                marginLeft: '8px',
                                                                color: blog.nivel === 'Iniciante' ? '#28a745' : 
                                                                       blog.nivel === 'Intermediário' ? '#ffc107' : '#dc3545'
                                                            }}>
                                                                {blog.nivel}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {blog.duracao && (
                                                        <div style={{ marginBottom: '4px' }}>
                                                            <strong>Duração:</strong> <span style={{ marginLeft: '8px' }}>{blog.duracao}</span>
                                                        </div>
                                                    )}
                                                    {blog.instrutor && (
                                                        <div style={{ marginBottom: '4px' }}>
                                                            <strong>Instrutor:</strong> <span style={{ marginLeft: '8px' }}>{blog.instrutor}</span>
                                                        </div>
                                                    )}
                                                    {blog.competencias && (
                                                        <div style={{ marginTop: '8px' }}>
                                                            <strong>Competências:</strong>
                                                            <div style={{ marginTop: '4px' }}>
                                                                {blog.competencias.map((comp, index) => (
                                                                    <span key={index} style={{ 
                                                                        display: 'inline-block',
                                                                        backgroundColor: '#f8f9fa', 
                                                                        padding: '2px 6px', 
                                                                        margin: '2px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        border: '1px solid #dee2e6'
                                                                    }}>
                                                                        {comp}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Todos os Eventos Educacionais */}
            <section id="todos-eventos" className="block blog-block" style={{ marginTop: '40px' }}>
                 <div className="title-holder" id="title-" style={{ textAlign: 'center', marginBottom: 32 }}>
                    <h1 style={{
                        fontWeight: 800,
                        fontSize: '2.4rem',
                        letterSpacing: '-1px',
                        color: '#00761F',
                        textShadow: '0 2px 12px rgba(0,0,0,0.07)'
                    }}>
                        <i className="bi bi-star-fill" style={{ color: '#ffc107', marginRight: 10, fontSize: 32, verticalAlign: 'middle' }} />
                        Todos os Eventos Educacionais
                    </h1>
                    <p style={{
                        color: '#555',
                        fontSize: '1.1rem',
                        fontWeight: 500,
                        marginTop: 8,
                        letterSpacing: '0.5px'
                    }}>
                        - Catálogo Completo de Formações e Workshops  -
                    </p>
                    <div style={{
                        width: 80,
                        height: 4,
                        background: 'linear-gradient(90deg, #00761F 0%, #ffc107 100%)',
                        borderRadius: 2,
                        margin: '18px auto 0'
                    }} />
                </div>
                
                {/* Filtros por categoria */}
                <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <div style={{ display: 'inline-flex', gap: '10px', flexWrap: 'wrap' }}>
                        <button 
                            className={`btn ${filtroAtivo === 'todos' ? 'btn-success' : 'btn-outline-success'}`}
                            onClick={() => setFiltroAtivo('todos')}
                        >
                            Todas Categorias
                        </button>
                        {categorias.map(cat => (
                            <button
                                key={cat}
                                className={`btn ${filtroAtivo === cat ? 'btn-success' : 'btn-outline-success'}`}
                                onClick={() => setFiltroAtivo(cat)}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>

                <Container fluid>
                    <Row>
                        {todosEventos
                            .filter(blog => {
                                if (filtroAtivo === 'todos') return true;
                                return blog.category === filtroAtivo;
                            })
                            .map(blog => (
                            <Col sm={4} key={blog.id}>
                                <div style={{ marginTop: '12px' }} className='holder'>
                                    <Card as={Link} to={`/evento/${blog.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <Card.Img variant="top" src={blog.image} />
                                        <Card.Body>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                <span style={{ color: '#00761F', fontWeight: '700' }}>{blog.category}</span>
                                                {blog.certificado && (
                                                    <span style={{ 
                                                        backgroundColor: '#007bff', 
                                                        color: 'white', 
                                                        padding: '2px 8px', 
                                                        borderRadius: '12px', 
                                                        fontSize: '12px' 
                                                    }}>
                                                        Certificado
                                                    </span>
                                                )}
                                            </div>
                                            <time>{blog.time}</time>
                                            <Card.Title>{blog.title}</Card.Title>
                                            <Card.Text>
                                                {blog.description}
                                            </Card.Text>
                                            
                                            {/* Informações educacionais resumidas */}
                                            <div style={{ marginTop: '12px' }}>
                                                {blog.nivel && (
                                                    <div style={{ marginBottom: '4px' }}>
                                                        <strong>Nível:</strong> 
                                                        <span style={{ 
                                                            marginLeft: '8px',
                                                            color: blog.nivel === 'Iniciante' ? '#28a745' : 
                                                                   blog.nivel === 'Intermediário' ? '#ffc107' : '#dc3545'
                                                        }}>
                                                            {blog.nivel}
                                                        </span>
                                                    </div>
                                                )}
                                                {blog.duracao && (
                                                    <div style={{ marginBottom: '4px' }}>
                                                        <strong>Duração:</strong> <span style={{ marginLeft: '8px' }}>{blog.duracao}</span>
                                                    </div>
                                                )}
                                                {blog.vagas && (
                                                    <div style={{ marginBottom: '4px' }}>
                                                        <strong>Vagas:</strong> 
                                                        <span style={{ 
                                                            marginLeft: '8px',
                                                            color: blog.vagas < 10 ? '#dc3545' : '#28a745'
                                                        }}>
                                                            {blog.vagas} disponíveis
                                                        </span>
                                                    </div>
                                                )}
                                                {blog.preco && (
                                                    <div style={{ marginTop: '8px' }}>
                                                        <strong style={{ 
                                                            color: blog.preco === 'Gratuito' ? '#28a745' : '#333',
                                                            fontSize: '16px'
                                                        }}>
                                                            {blog.preco}
                                                        </strong>
                                                    </div>
                                                )}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </main>
        <AppLayout />
        </div>
    )
}
